import React from "react";

import Image from "../../../components/image";
import { useTheme } from "../../../context/ThemeContext";
import LeafBg from "../../../images/focusLeafDarkBg.png";
import PeopleBg from "../../../images/HomeBGImage.jpeg";
import ProductTypeFilter from "../filters/productTypeFilter";

const TwoColumnHero = ({
  headTitle,
  headSubtitle,
  heroBackgroundImage,
  locationSummary,
  featureMapIllustration = false,
  hasCollapsibleWrapper = true,
  sectionContainerStyles = "bg-generic-bg",
  pageType = "focus",
  selectedTypeFilter = "",
  baseLocations = [],
  programTypeFilterCounter = [],
  setTriggerTypeFilter = () => {}
}) => {
  const { colorMode } = useTheme();
  return (
    <>
      <div
        className={`relative flex flex-col items-center justify-center headinfo-section mx-auto ${sectionContainerStyles}`}
      >
        <div
          className={`hidden sm:flex justify-start absolute top-0 left-0 sm:w-full`}
        >
          {colorMode === "dark" ? (
            <Image
              imageAlt=""
              image={""}
              imageClass="hidden sm:block object-cover object-center w-full"
              sourceUrl={LeafBg}
            />
          ) : (
            <Image
              imageAlt=""
              image={""}
              imageClass="hidden  sm:block object-cover object-center w-full"
              sourceUrl={PeopleBg}
            />
          )}
        </div>

        <div className="absolute top-0 left-0 right-0 bottom-0 flex flex-col w-full">
          <div className="flex flex-col md:flex-row">
            <div className="relative w-full sm:w-1/2">
              {featureMapIllustration}

              <div className="flex flex-col flex-wrap w-full sm:w-4/6 sm:mx-auto sm:py-16 px-2 sm:px-0">
                <h1
                  className="font-normal dark:font-light font-alice dark:font-body sm:pb-6 leading-10"
                  dangerouslySetInnerHTML={{ __html: headTitle }}
                />

                <div
                  className={`flex flex-row items-start justify-between mt-4 sm:mt-0 ${
                    hasCollapsibleWrapper ? "" : "border-none"
                  }`}
                >
                  <div className="flex flex-col w-full sm:justify-left sm:w-10/12 ">
                    {headSubtitle && (
                      <h3
                        className="font-normal dark:font-light text-section-title-text"
                        dangerouslySetInnerHTML={{ __html: headSubtitle }}
                      />
                    )}

                    {locationSummary && (
                      <div
                        className="font-normal dark:font-light text-section-title-text text-sm py-3 overflow-hidden"
                        dangerouslySetInnerHTML={{
                          __html: locationSummary
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={`relative hidden sm:block w-1/2 h-102`}>
              {pageType === "location" ? (
                <div className="flex flex-col flex-wrap w-full sm:py-16">
                  <h1
                    className="font-normal dark:font-light font-alice dark:font-body sm:pb-6 leading-10"
                    dangerouslySetInnerHTML={{ __html: "Filter programs" }}
                  />
                  <div className="">
                    <ProductTypeFilter
                      setFilterOption={setTriggerTypeFilter}
                      selectedType={selectedTypeFilter}
                      programCounter={programTypeFilterCounter}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className={`absolute z-10 opacity-80 top-0 left-0 w-full h-full location-bg gvi-ease-in-out`}
                    style={{
                      backgroundImage:
                        "linear-gradient(rgba(0,0,0,0.37),rgba(0,0,0,0.37))"
                    }}
                  />
                  <Image
                    imageAlt=""
                    image={""}
                    imageClass="w-full h-full object-cover z-10"
                    sourceUrl={heroBackgroundImage}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwoColumnHero;
